import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import {
  homeItems,
  blogItems,
  pageItems,
  dashboardItems,
  categorieMobileItems,
  categorieMegaMenuItems,
} from "../../data/mainMenuData";
import { isActiveLink } from "../../utils/linkActiveChecker";
import Social from "../common/social/Social";
import ContactInfo from "./ContactInfo";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {DateObject} from "react-multi-date-picker";

const MobileMenu = () => {
  const { pathname } = useLocation();

  const [isActiveParent, setIsActiveParent] = useState(false);
  const [isActiveNestedParentTwo, setisActiveNestedParentTwo] = useState(false);
  const [isActiveNestedParent, setisActiveNestedParent] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    categorieMegaMenuItems.map((megaMenu) => {
      megaMenu?.menuCol?.map((megaCol) => {
        megaCol?.menuItems?.map((item) => {
          item?.menuList?.map((list) => {
            if (list.routePath?.split("/")[1] == pathname.split("/")[1]) {
              setIsActiveParent(true);
              setisActiveNestedParentTwo(item?.title);
              setisActiveNestedParent(megaMenu?.id);
            }
          });
        });
      });
    });
  }, []);

  function getRoutePath(menu, i) {
    if(menu.id === 6) {
      return menu.routePath + '&dateFrom=' + new DateObject().format('YYYY-MM-DD') + '&dateTo=' + new DateObject().add(14, 'days').format('YYYY-MM-DD')
    }
    return menu.routePath;
  }

  return (
    <>
      <div className="pro-header d-flex align-items-center justify-between border-bottom-light">
        <Link to="/">
          <img src="/img/general/logo.svg" alt="brand" style={{width: '40%'}} />
        </Link>
        {/* End logo */}

        <div
          className="fix-icon"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i className="icon icon-close"></i>
        </div>
      </div>
      {/* End pro-header */}

      <Sidebar width="400" backgroundColor="#fff">
        <Menu>
          <MenuItem component={<Link to="/" />}>Strona główna</MenuItem>
          <SubMenu
            label="Loty"
            className={
              pathname === "/flights" || pathname === "/best-flights"
                ? "menu-active-link"
                : ""
            }
          >
            <MenuItem
              component={<Link to="/flights" />}
              className={
                pathname === "/flights" ? "menu-active-link" : "inactive-menu"
              }
            >
              Szukaj lotów
            </MenuItem>
            <MenuItem
              component={<Link to="/best-flights" />}
              className={
                pathname === "/best-flights"
                  ? "menu-active-link"
                  : "inactive-menu"
              }
            >
              Najlepsze loty
            </MenuItem>
          </SubMenu>
          {/* End Loty menu */}
          <MenuItem component={<Link to="/best-offers" />}>Najlepsze oferty</MenuItem>
          {/* End  All Home Menu */}

          <MenuItem
            component={<Link to="/map" />}
            className={pathname === "/map" ? "menu-active-link" : ""}
          >
            Mapa ofert
          </MenuItem>
          {/* End map menu item */}

          <SubMenu
            label="Zainspiruj się"
            className={isActiveParent ? "menu-active-link" : ""}
          >
            {categorieMobileItems.map((item) => (
              <SubMenu
                label={item.title}
                key={item.id}
                className={
                  isActiveNestedParent == item.id
                    ? "menu-active-link"
                    : "inactive-menu"
                }
              >
                {/*{item.menuItems.map((single) => (*/}
                {/*  <SubMenu*/}
                {/*    label={single.title}*/}
                {/*    key={single.id}*/}
                {/*    className={*/}
                {/*      isActiveNestedParentTwo == single.title*/}
                {/*        ? "menu-active-link"*/}
                {/*        : "inactive-menu"*/}
                {/*    }*/}
                {/*  >*/}
                    {item.menuItems.map((menu, i) => (
                      <MenuItem
                        key={i}
                        component={<Link reloadDocument to={getRoutePath(menu, i)} />}
                        className={
                          isActiveLink(menu.routePath, pathname)
                            ? "menu-active-link"
                            : "inactive-menu"
                        }
                      >
                        {menu.name}
                      </MenuItem>
                    ))}
                  {/*</SubMenu>*/}
              </SubMenu>
            ))}
          </SubMenu>
          {/* End  All Categories Menu */}

          <MenuItem component={<Link to="/tour-list-v2" />}>Ulubione</MenuItem>
          {/* End  Desitinations Menu */}

          <MenuItem
            component={<Link to="/blog" />}
            className={pathname === "/blog" || pathname.startsWith("/blog/") ? "menu-active-link" : ""}
          >
            Blog
          </MenuItem>
          {/* End Blog menu item */}

          {/*<SubMenu*/}
          {/*  label="Blog"*/}
          {/*  className={*/}
          {/*    blogItems.some(*/}
          {/*      (item) =>*/}
          {/*        item.routePath?.split("/")[1] == pathname.split("/")[1],*/}
          {/*    )*/}
          {/*      ? "menu-active-link"*/}
          {/*      : ""*/}
          {/*  }*/}
          {/*>*/}
          {/*  {blogItems.map((item, i) => (*/}
          {/*    <MenuItem*/}
          {/*      key={i}*/}
          {/*      onClick={() => navigate(item.routePath)}*/}
          {/*      className={*/}
          {/*        isActiveLink(item.routePath, pathname)*/}
          {/*          ? "menu-active-link"*/}
          {/*          : "inactive-menu"*/}
          {/*      }*/}
          {/*    >*/}
          {/*      {item.name}*/}
          {/*    </MenuItem>*/}
          {/*  ))}*/}
          {/*</SubMenu>*/}
          {/*/!* End  All Blog Menu *!/*/}

          {/*<SubMenu*/}
          {/*  label="Pages"*/}
          {/*  className={*/}
          {/*    pageItems.some(*/}
          {/*      (item) =>*/}
          {/*        item.routePath?.split("/")[1] == pathname.split("/")[1],*/}
          {/*    )*/}
          {/*      ? "menu-active-link"*/}
          {/*      : ""*/}
          {/*  }*/}
          {/*>*/}
          {/*  {pageItems.map((item, i) => (*/}
          {/*    <MenuItem*/}
          {/*      key={i}*/}
          {/*      onClick={() => navigate(item.routePath)}*/}
          {/*      className={*/}
          {/*        isActiveLink(item.routePath, pathname)*/}
          {/*          ? "menu-active-link"*/}
          {/*          : "inactive-menu"*/}
          {/*      }*/}
          {/*    >*/}
          {/*      {item.name}*/}
          {/*    </MenuItem>*/}
          {/*  ))}*/}
          {/*</SubMenu>*/}
          {/*/!* End  All Pages Menu *!/*/}

          {/*<SubMenu*/}
          {/*  label="Dashboard"*/}
          {/*  className={*/}
          {/*    pathname.split("/")[1] == "dashboard" ||*/}
          {/*    pathname.split("/")[1] == "vendor-dashboard"*/}
          {/*      ? "menu-active-link"*/}
          {/*      : ""*/}
          {/*  }*/}
          {/*>*/}
          {/*  {dashboardItems.map((item, i) => (*/}
          {/*    <MenuItem*/}
          {/*      key={i}*/}
          {/*      onClick={() => navigate(item.routePath)}*/}
          {/*      className={*/}
          {/*        isActiveLink(item.routePath, pathname)*/}
          {/*          ? "menu-active-link"*/}
          {/*          : "inactive-menu"*/}
          {/*      }*/}
          {/*    >*/}
          {/*      {item.name}*/}
          {/*    </MenuItem>*/}
          {/*  ))}*/}
          {/*</SubMenu>*/}
          {/*/!* End  All Dashboard Menu *!/*/}

          <MenuItem
            component={<Link to="/contact" />}
            className={pathname === "/contact" ? "menu-active-link" : ""}
          >
            Informacje
          </MenuItem>
          {/* End Contact  Menu */}
        </Menu>
      </Sidebar>

      <div className="mobile-footer px-20 py-5 border-top-light"></div>

      <div className="pro-footer">
        {/*<ContactInfo />*/}
        {/*<div className="mt-10">*/}
        {/*  <h5 className="text-16 fw-500 mb-10">Follow us on social media</h5>*/}
        {/*  <div className="d-flex x-gap-20 items-center">*/}
        {/*    <Social />*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div className="mt-20">*/}
        {/*  <Link*/}
        {/*    className=" button -dark-1 px-30 fw-400 text-14 bg-blue-1 h-50 text-white"*/}
        {/*    to="/login"*/}
        {/*  >*/}
        {/*    Become An Expert*/}
        {/*  </Link>*/}
        {/*</div>*/}
      </div>
      {/* End pro-footer */}
    </>
  );
};

export default MobileMenu;
